import { fetchLineUpData } from 'api/services/epg';
import {
  FETCH_EPG_LINE_UP_ERROR,
  FETCH_EPG_LINE_UP_INIT,
  FETCH_EPG_LINE_UP_SUCCESS,
} from 'actions/epgLineUp';

export const fetchEpgLineUp = (params = {}) => async dispatch => {
  dispatch({ type: FETCH_EPG_LINE_UP_INIT });

  const paramsEpg = {
    ...params,
    tenant_code: 'clarovideo',
    type: 'epg',
    metadata: 'full',
    quantity: 200,
  };

  try {
    let {
      data: { response },
    } = await fetchLineUpData({ ...paramsEpg });

    if (response?.total > paramsEpg.quantity) {
      paramsEpg.quantity = response?.total;
      const responseFromEpgLineup = await fetchLineUpData({ ...paramsEpg });
      response = responseFromEpgLineup?.data?.response;
    }

    const dataEpgLineUp = JSON.stringify(response);
    if (response) {
      dispatch({
        type: FETCH_EPG_LINE_UP_SUCCESS,
        payload: response?.channels,
        quantity: response?.total,
      });
      localStorage.setItem('epgLineUp', dataEpgLineUp);
    }
  } catch (error) {
    dispatch({
      type: FETCH_EPG_LINE_UP_ERROR,
      error,
    });
  }
};
